[
  {
    "id": "ad7a8aac-8718-4585-924e-55100f495abb",
    "title": "Gap",
    "category": "clothes",
    "amount": 432.87,
    "date": "2022-01-05",
    "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore, corrupti.",
    "paymentType": "card",
    "type": "expense"
  },
  {
    "id": "94d22477-3870-43d6-935e-7483e06fbd94",
    "title": "M&S Food Court",
    "category": "food",
    "amount": 15.26,
    "date": "2022-01-07",
    "description": "Lorem ipsum dolor sit amet.",
    "paymentType": "card",
    "type": "income"
  },
  {
    "id": "363e34d9-6181-40cc-ac85-f19695f422ca",
    "title": "Tesco Petrol",
    "category": "fuel",
    "amount": 150.04,
    "date": "2022-01-12",
    "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit.",
    "paymentType": "card",
    "type": "expense"
  },
  {
    "id": "58f2124a-ab8b-4b88-bb0d-e2dabf00ac94",
    "title": "Netlix",
    "category": "entertainment",
    "amount": 7.99,
    "date": "2022-01-13",
    "description": "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci non voluptatem saepe?",
    "paymentType": "card",
    "type": "expense"
  },
  {
    "id": "ad7a8aac-8718-4585-924e-55100f495abc",
    "title": "Timberland",
    "category": "clothes",
    "amount": 710.2,
    "date": "2022-01-04",
    "description": "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
    "paymentType": "card",
    "type": "income"
  }
]
